import React, { useEffect } from "react";
import {
  Button,
  ContactForm,
  DynamicVideoCarousel,
} from "../components/template";

import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import RebootPopup from "./RebootPopup";

const HeroSection = () => {
  useEffect(() => {
    const img = new Image();
    img.src = "/assets/home/B1.jpg";
  }, []);

  /* BENEFITS */

  const benefits = [
    { icon: "❤️", text: "Health " },
    { icon: "🧠", text: "Harmony" },
    { icon: "✨", text: "Happiness" },
  ];

  /* OFFERINGS */

  const offerings = [
    {
      tag: "RETREAT",
      title: "Transformative Retreats",
      description:
        "Immersive wellness experiences combining Yoga, Ayurveda, Meditation, and Positive Psychology.",
      image: "/assets/home/Transformative Retreats.jpeg",
      link: "/retreats",
    },

    {
      tag: "CORPORATE",
      title: "Corporate Programs",
      description:
        "Scientifically designed experiences for productivity, clarity, emotional wellbeing, and team energy.",
      image: "/assets/home/Corporate.jpeg",
      link: "/corporate-wellness",
    },

    {
      tag: "ONLINE",
      title: "PARAM App",
      description:
        "Access Guided practices, Online programs, Habit builder, motivational content, and much more through PARAM App.",
      image: "/assets/home/Online programs.jpg",
      link: "/online-programs",
    },
  ];

  /* WHY PARAM */

  const statusPoints = [
    { icon: "🧘", text: "Holistic Approach" },
    { icon: "🔬", text: "Scientific Techniques" },
    { icon: "🌟", text: "Personalized Impact" },
    { icon: "🎯", text: "Actionable Take-aways" },
    { icon: "📝", text: "Lasting Benefits" },
    { icon: "🤝", text: "Continuous Guidance" },
  ];

  const testimonialVideos = [
    "https://www.youtube.com/embed/yz4INHZkJNI",
    "https://www.youtube.com/embed/0E8hm2fdxCs",
    "https://www.youtube.com/embed/cHuh-cGuYmg",
  ];
const founders = [ { name: "Gaurv Parmarthy", role: "Founder & CEO", education: "IIT Kharagpur ·Sivananda Yoga Vedanta Academy ", image: "/assets/aboutpg/Founder.png", initials: "GP", linkedin: "https://www.linkedin.com/in/gaurav-bansal-b429b63a/",tag:"Inner Growth Mentor" }, { name: "Monika Meena", role: "Chief Marketing Officer",tag:"Holistic Wellness Coach", education: "DU · IIM Lucknow · Sivananda Yoga Vedanta Academy", image: "/assets/aboutpg/Cofounder.png", initials: "MM", linkedin: "https://www.linkedin.com/in/monika-meena-883461b2/", }, ];
  return (
    <>

      {/* =========================================================
         HERO SECTION
      ========================================================= */}
<section
  className="
    relative
    overflow-hidden
    min-h-screen
    flex
    items-center
    px-5
    sm:px-8
    py-20
    lg:py-12
  "
  style={{
    backgroundImage: `
      linear-gradient(
        to bottom,
        rgba(0,0,0,.72),
        rgba(0,0,0,.58)
      ),
      url('/assets/home/B1.jpg')
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  {/* Ambient Glow */}
  <div className="absolute top-[-160px] right-[-120px] w-[420px] lg:w-[520px] h-[420px] lg:h-[520px] rounded-full bg-[#F28C28]/20 blur-[120px]" />

  <div className="relative z-10 max-w-[1320px] mx-auto w-full">
    <div className="grid lg:grid-cols-2 gap-12 items-center">

      {/* LEFT */}
      <div className="max-w-2xl">

        {/* Heading */}
        <h1
          className="
            flex
            flex-col
            sm:flex-row
            sm:flex-wrap
            gap-y-2
            sm:gap-x-5
            mb-8
            leading-[1.1]
            text-white
          "
          style={{ fontWeight: 400 }}
        >
          <span className="text-[40px] sm:text-[54px] lg:text-[54px] tracking-[-0.03em]">
            Redesign Your Life.
          </span>

          <span className="text-[40px] sm:text-[54px] lg:text-[54px] tracking-[-0.03em] text-white/90">
            Discover Your Best Self.
          </span>

          <span className="text-[40px] sm:text-[54px] lg:text-[54px] tracking-[-0.03em] text-white/75">
            Experience The Highest.
          </span>
        </h1>

        {/* Benefits */}
        <div className="space-y-4 max-w-[560px] mt-8">
          {benefits.map((item, index) => (
            <div
              key={index}
              className="
                flex
                items-center
                gap-3
                bg-white/10
                backdrop-blur-xl
                border
                border-white/10
                rounded-2xl
                px-4
                py-3
              "
            >
              <div
                className="
                  w-10
                  h-10
                  rounded-full
                  bg-white/10
                  flex
                  items-center
                  justify-center
                  text-lg
                  flex-shrink-0
                "
              >
                {item.icon}
              </div>

              <span className="text-white text-base sm:text-lg lg:text-xl font-medium">
                {item.text}
              </span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10">
          <Link
            to="/retreats"
            className="
              inline-flex
              w-full
              sm:w-auto
              items-center
              justify-center
              h-14
              px-8
              rounded-full
              text-white
              font-semibold
              text-base
              transition-all
              duration-300
              hover:scale-[1.02]
              hover:shadow-[0_18px_40px_rgba(242,140,40,.28)]
            "
            style={{
              background:
                "linear-gradient(135deg,#F28C28,#F6A04D)",
            }}
          >
            Explore Offerings →
          </Link>
        </div>

      </div>
    </div>
  </div>
</section>
      {/* =========================================================
         OFFERINGS
      ========================================================= */}

      <section
        className="
          relative
          overflow-hidden
          py-28
          px-6
          bg-[#FAF8F5]
        "
      >
        <div className="absolute top-[-120px] left-[-120px] w-[400px] h-[400px] rounded-full bg-[#F28C28]/10 blur-[120px]" />

        <div className="max-w-[1320px] mx-auto relative z-10">
          {/* HEADER */}
          <div className="text-center mb-20">
            {/* <div
              className="
                inline-flex
                items-center
                px-6
                py-4
                rounded-full
                bg-[#FFF1E4]
                text-[#F28C28]
                text-m
                font-semibold
                tracking-[.08em]
                mb-6
              "
            >
              WHAT WE OFFER
            </div> */}

            <h2
              className="
                text-[clamp(42px,6vw,78px)]
                leading-[1.02]
                tracking-[-0.05em]
                text-secondary
                mb-5
              "
              style={{
                fontWeight: 400,
              }}
            >Our Offerings
            </h2>

            {/* <p
              className="
                max-w-[720px]
                mx-auto
                text-[#6B574A]
                text-[17px]
                leading-9
              "
            >
              Programs crafted to help you feel
              healthier, calmer, emotionally stronger,
              and more aligned with yourself.
            </p> */}
          </div>

          {/* CARDS */}
          <div
            className="
              grid
              grid-cols-1
              md:grid-cols-2
              xl:grid-cols-3
              gap-8
            "
          >
            {offerings.map((offering, index) => (
              <Link
                key={index}
                to={offering.link}
                className="
                  group
                  relative
                  overflow-hidden
                  rounded-[34px]
                  h-[500px]
                  bg-black
                  shadow-[0_30px_80px_rgba(20,10,0,.12)]
                  transition-all
                  duration-500
                  hover:-translate-y-2
                "
              >
                {/* IMAGE */}
                <img
                  src={offering.image}
                  alt={offering.title}
                  className="
                    w-full
                    h-full
                    object-cover
                    brightness-[.84]
                    saturate-[.9]
                    transition-transform
                    duration-700
                    group-hover:scale-105
                  "
                />

                {/* OVERLAY */}
                <div
                  className="
                    absolute
                    inset-0
                    bg-gradient-to-t
                    from-black/90
                    via-black/35
                    to-transparent
                  "
                />

                {/* TAG */}
                <div
                  className="
                    absolute
                    top-5
                    left-5
                    px-4
                    py-2
                    rounded-full
                    bg-white/10
                    backdrop-blur-xl
                    border
                    border-white/10
                    text-white
                    text-xs
                    tracking-[.08em]
                  "
                >
                  {offering.tag}
                </div>

                {/* CONTENT */}
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <div
                    className="
                      rounded-[28px]
                      bg-white/10
                      backdrop-blur-2xl
                      border
                      border-white/10
                      p-6
                    "
                  >
                    <h3
                      className="
                        text-[30px]
                        leading-[1.05]
                        tracking-[-0.03em]
                        text-[#FFF8F2]
                        mb-4
                      "
                    >
                      {offering.title}
                    </h3>

                    <p
                      className="
                        text-white/70
                        leading-8
                        text-[15px]
                        mb-6
                        line-clamp-3
                      "
                    >
                      {offering.description}
                    </p>

                    <div
                      className="
                        inline-flex
                        items-center
                        gap-2
                        text-white
                        font-semibold
                        text-sm
                      "
                    >
                      Explore Experience
                      <ArrowRight size={15} />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* =========================================================
         WHY CHOOSE PARAM
      ========================================================= */}

<section className="relative py-20 bg-[#F7F1EA] overflow-hidden">

  {/* BG GLOWS */}
<section className="relative py-20 bg-[#F7F1EA] overflow-hidden">

{/* BG GLOWS */}

  <div className="absolute top-0 left-0 w-64 h-64 bg-[#E8C8A7]/20 blur-3xl rounded-full" />
  <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#DDBA99]/15 blur-3xl rounded-full" />

  <div className="relative max-w-[1320px] mx-auto px-6">


<div
  className="
    grid
    grid-cols-1
    lg:grid-cols-[1.02fr_.98fr]
    gap-14
    items-center
  "
>

  {/* IMAGE SIDE */}
  <div
    className="
      group
      relative
      overflow-hidden
      rounded-[34px]
      h-[620px]
      lg:h-[650px]
      shadow-[0_25px_60px_rgba(20,10,0,.10)]
    "
  >

    <img
      src="/assets/home/Why choose Param.jpg"
      alt="Why Choose Param Life"
      className="
        w-full
        h-full
        object-cover
        transition-transform
        duration-700
        group-hover:scale-105
      "
    />

    <div
      className="
        absolute
        inset-0
        bg-gradient-to-t
        from-black/75
        via-black/15
        to-transparent
      "
    />

    <div className="absolute bottom-6 left-6 right-6">
      <div
        className="
          rounded-[24px]
          bg-white/10
          backdrop-blur-2xl
          border
          border-white/10
          p-6
        "
      >

        <div
          className="
            text-[#E7C4A1]
            text-[10px]
            tracking-[.18em]
            uppercase
            mb-3
          "
        >
          Holistic Wellbeing
        </div>

        <h3
          className="
            text-[30px]
            leading-[1]
            tracking-[-0.04em]
            text-white
            mb-4
          "
        >
          Transform your life within.
        </h3>

        <p
          className="
            text-white/75
            text-[14px]
            leading-7
          "
        >
          Sustainable growth through psychology,
          mindfulness, yoga, neuroscience and Ayurveda.
        </p>

      </div>
    </div>
  </div>

  {/* CONTENT SIDE */}
  <div className="flex flex-col justify-center">

    <div
      className="
        inline-flex
        items-center
        px-4
        py-2
        rounded-full
        bg-[#FFF4E8]
        border
        border-[#F3DDC7]
        text-[#C26B2E]
        text-[10px]
        tracking-[.18em]
        uppercase
        font-medium
        mb-5
        w-fit
      "
    >
      Our Methodology
    </div>

    <h2
      className="
        text-[clamp(42px,4.5vw,62px)]
        leading-[0.95]
        tracking-[-0.05em]
        text-secondary
        mb-5
      "
      style={{ fontWeight: 400 }}
    >
      Why PARAM
      <br />
      works so well?
    </h2>

    <p
      className="
        text-[#5F5751]
        text-[16px]
        leading-8
        mb-8
        max-w-[560px]
      "
    >
      Our methodology combines Positive Psychology,
      Yoga, Ayurveda, mindfulness, and neuroscience
      to create deep, sustainable transformation and
      long-lasting wellbeing.
    </p>

    <div
      className="
        grid
        grid-cols-1
        sm:grid-cols-2
        gap-4
      "
    >

      {statusPoints.map((item, index) => (
        <div
          key={index}
          className="
            group
            relative
            overflow-hidden
            rounded-[24px]
            bg-white/70
            backdrop-blur-2xl
            border
            border-white/40
            shadow-[0_15px_40px_rgba(20,10,0,.04)]
            p-2
            transition-all
            duration-500
            hover:-translate-y-1.5
          "
        >

          <div
            className="
              absolute
              top-0
              right-0
              w-24
              h-20
              bg-[#F4D8BE]/20
              blur-3xl
              rounded-full
            "
          />

          <div className="relative z-10">

            <div
              className="
                w-12
                h-10
                rounded-full
                bg-[#FFF4E8]
                border
                border-[#F3DDC7]
                flex
                items-center
                justify-center
                text-xl
                mb-4
              "
            >
              {item.icon}
            </div>

            <h3
              className="
                text-[18px]
                leading-[1.1]
                tracking-[-0.03em]
                text-[#2A140D]
                mb-3
              "
              style={{
                fontWeight: 400,
              }}
            >
              {item.text}
            </h3>


          </div>
        </div>
      ))}

    </div>

  </div>

</div>


  </div>

</section>
</section>


      {/* IMPACT STORIES */}

<section className="py-24 bg-[#FFF1E4]">
  <div className="max-w-[1320px] mx-auto px-6">
    
    <div className="grid lg:grid-cols-2 gap-16 items-center">
      
      {/* LEFT CONTENT */}
      <div>
        <span
          className="
            inline-flex
            items-center
            px-5
            py-2
            rounded-full
            bg-[#F28C28]/10
            text-[#C96B12]
            text-xs
            tracking-[.12em]
            font-semibold
            mb-6
          "
        >
          TRANSFORMATION JOURNEYS
        </span>

        <h2
          className="
            text-[clamp(42px,6vw,82px)]
            leading-[0.95]
            tracking-[-0.05em]
            text-secondary
            mb-8
          "
          style={{
            fontWeight: 400,
          }}
        >
          Impact
          Stories
        </h2>

        <p
          className="
            text-[#444]
            text-[17px]
            leading-9
            max-w-[520px]
          "
        >
          Hear real stories of transformation,
          healing, growth, and breakthroughs from
          individuals who experienced the Param
          Life journey.
        </p>
      </div>

      {/* RIGHT VIDEO SECTION */}
      <div>
        <DynamicVideoCarousel
          heading=""
          videos={testimonialVideos}
        />
      </div>
    </div>

  </div>
</section>      {/* CONTACT */}
{/* =========================================================
   WHO WE ARE
========================================================= */}
<section className="relative py-24 bg-[#F7F1EA] overflow-hidden">
  {/* BG GLOW */}
  <div className="absolute top-0 left-0 w-72 h-72 bg-[#E8C9A8]/30 blur-3xl rounded-full" />
  <div className="absolute bottom-0 right-0 w-72 h-72 bg-[#D8B89C]/20 blur-3xl rounded-full" />

  <div className="relative max-w-[1280px] mx-auto px-6">

    {/* LABEL */}
    <div className="flex justify-center mb-5">
      <div
        className="
          px-5
          py-2
          rounded-full
          bg-[#FFF4E8]
          border
          border-[#F3DDC7]
          text-[#C26B2E]
          text-[11px]
          tracking-[.18em]
          uppercase
          font-medium
        "
      >
        About Param Life
      </div>
    </div>

    {/* HEADING */}
    <h2
      className="
        text-center
        text-4xl
        md:text-6xl
        font-bold
        text-secondary
        mb-16
      "
    >
      Meet The Founders
    </h2>

    {/* FOUNDERS GRID */}
    <div
      className="
        grid
        grid-cols-1
        md:grid-cols-2
        gap-8
        mb-16
      "
    >
      {founders.map((founder, index) => (
        <div
          key={index}
          className="
            group
            relative
            overflow-hidden
            rounded-[34px]
            bg-white
            border
            border-[#EFE4D8]
            p-7
            md:p-8
            shadow-[0_20px_60px_rgba(36,22,15,.06)]
            hover:-translate-y-2
            transition-all
            duration-500
          "
        >
          {/* SOFT GLOW */}
          <div
            className="
              absolute
              top-0
              right-0
              w-40
              h-40
              bg-[#F5DCC4]/30
              blur-3xl
              rounded-full
            "
          />

          <div className="relative z-10">
            {/* TOP */}
            <div className="flex items-center gap-5">


              {/* IMAGE */}
              <div
                className="
                  w-24
                  h-24
                  rounded-full
                  overflow-hidden
                  border-4
                  border-[#F4E1CF]
                  shadow-lg
                  shrink-0
                "
              >
                <img
                  src={founder.image}
                  alt={founder.name}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* INFO */}
              <div className="text-left">
                <h3
                  className="
                    text-2xl
                    md:text-3xl
                    font-bold
                    text-secondary
                    mb-2
                  "
                >
                  {founder.name}
                </h3>

{founder.tag && (
  <p
    className="
      text-xs
      uppercase
      tracking-[0.15em]
      text-[#A57A5A]
      font-semibold
      mb-2
    "
  >
    {founder.tag}
  </p>
)}
                <p
                  className="
                    text-[#C26B2E]
                    text-[15px]
                    font-medium
                    mb-2
                  "
                >
                  {founder.role}
                </p>

                <p
                  className="
                    text-[#6B625B]
                    text-sm
                    leading-6
                  "
                >
                  {founder.education}
                </p>
              </div>
            </div>

            {/* BUTTON */}
            <div className="mt-7">
              <a
                href={founder.linkedin}
                target="_blank"
                rel="noreferrer"
                className="
                  inline-flex
                  items-center
                  gap-2
                  px-5
                  h-11
                  rounded-full
                  bg-accent
                  text-pink
                  text-sm
                  font-medium
                  transition-all
                  duration-300
                  hover:scale-[1.03]
                "
              >
                View LinkedIn ↗
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>

    {/* STORY SECTION */}
    <div
      className="
        relative
        overflow-hidden
        rounded-[40px]
        bg-white
        border
        border-[#EFE4D8]
        shadow-[0_20px_80px_rgba(36,22,15,.05)]
        p-8
        md:p-14
      "
    >
      <div
        className="
          absolute
          -top-20
          right-0
          w-72
          h-72
          bg-[#F7E0C8]/30
          blur-3xl
          rounded-full
        "
      />

      <div className="relative z-10">
        <div
          className="
            grid
            md:grid-cols-3
            gap-10
          "
        >
          {/* LEFT */}
          <div>
            <div
              className="
                inline-flex
                items-center
                px-4
                py-2
                rounded-full
                bg-[#FFF4E8]
                border
                border-[#F3DDC7]
                text-[#C26B2E]
                text-[11px]
                tracking-[.16em]
                uppercase
                mb-5
              "
            >
              Our Story
            </div>

            <h3
              className="
                text-4xl
                md:text-6xl
                font-bold
                leading-tight
                text-secondary
              "
            >
              Why
              <br />
              Param
              <br />
              Exists
            </h3>
          </div>

          {/* RIGHT */}
          <div className="md:col-span-2 space-y-6">
            <p className="text-[#5F5751] text-[16px] leading-8">
              “Param” is a Sanskrit word meaning the highest, the ultimate,
              the most supreme. At Param Life, we help people unlock their
              highest potential — where success does not cost health, and
              ambition does not come at the expense of inner peace.
            </p>

            <p className="text-[#5F5751] text-[16px] leading-8">
              We believe the best life is not built on compromise — but on
              wholeness. A life where prosperity, vibrant health, emotional
              balance, meaningful relationships, and deep joy can co-exist
              together.
            </p>

            <p className="text-[#5F5751] text-[16px] leading-8">
              After years in demanding corporate leadership roles, Gaurv and
              Monika realized that conventional success alone could never
              create lasting fulfillment. Param Life was born from the vision
              to bridge external achievement with internal wellbeing.
            </p>

            <div className="pt-4">
              <Link
                to="/about"
                className="
                  inline-flex
                  items-center
                  justify-center
                  h-12
                  px-7
                  rounded-full
                  bg-primary
                  text-white
                  text-sm
                  font-medium
                  transition-all
                  duration-300
                  hover:scale-[1.03]
                "
              >
                Know More About Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>
<section
  className="
    relative
    overflow-hidden
    py-24
    px-6
    bg-[#F6F3EE]
  "
>
  <div className="max-w-[760px] mx-auto text-center">

    {/* LABEL */}
    <div
      className="
        inline-flex
        items-center
        px-4
        py-2
        rounded-full
        bg-white
        border
        border-[#E7E2DA]
        text-[#6E8B75]
        text-[11px]
        font-medium
        tracking-[.14em]
        mb-6
      "
    >
      GET IN TOUCH
    </div>

    {/* HEADING */}
    <h2
      className="
        text-[clamp(40px,5vw,66px)]
        leading-[1]
        tracking-[-0.05em]
        text-secondary
        mb-5
      "
      style={{
        fontWeight: 400,
      }}
    >
      Begin your
      <br />
      wellness evolution
    </h2>

    {/* DESCRIPTION */}
    <p
      className="
        max-w-[620px]
        mx-auto
        text-[#6D655F]
        text-[15px]
        leading-8
        mb-10
      "
    >
      Have a query, want to collaborate,
      partner with us, or join the Param
      ecosystem? We'd love to hear from you.
    </p>

    {/* CLEAN LIGHT CARD */}
    <div
      className="
        rounded-[30px]
        bg-white
        border
        border-[#ECE7E1]
        p-8
        shadow-[0_10px_30px_rgba(0,0,0,.04)]
      "
    >
      <ContactForm para="" />
    </div>
  </div>
</section>
    </>
  );
};

export default HeroSection;
